import cn from 'classnames';
import { Children } from 'react';
import { CheckIcon } from '#assets/ReactSvg.ts';
import styles from './CheckmarkList.module.css';

type Props = {
  twoColumn?: boolean;
  children: React.ReactNode[];
  className?: string;
};

/**
 * Renders a ul, wrapping children in a li, adding a checkmark in front, and applying some styles
 */
export function CheckmarkList({ twoColumn, children, className }: Props) {
  const listItems = Children.map(children, (child) => (
    <li className={cn('h6 flex gap-8 align-center nowrap', className, styles.CheckmarkList_listItem)}>
      <CheckIcon className={styles.CheckmarkList_check} height={16} width={16} />
      {child}
    </li>
  ));

  return <ul className={cn('list-inline mb-24', { [styles.CheckmarkList___grid]: twoColumn })}>{listItems}</ul>;
}
